if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) { 
$(function() {
  
  //$("#accordion").accordion({ autoHeight: true});
  /*$("#accordion-33").accordion({ 
    header: "h3",
    collapsible: true,
    autoHeight: false,
    navigation: true
  });*/
  
  $("#accordion h3").click(function(){ 
    var target = $(this).data('tab');
    $(target).slideToggle();
    
    $(this).toggleClass('ui-accordion-header-active');
  });

  /* move to siejunior.js
  $("ul.site-footer__linklist h4").click(function(){
    $(this).parent("ul").toggleClass("ulmin");
    $(this).parent("ul").find("li").toggle();
  });*/
  
  $(".add-success .content .action .btn.continue").click(function(){
    $(".add-success").hide();
    //location.reload(true);
  });
  
  $(".site-header__cart").click(function(e){
    //e.preventDefault()
    //$(".mini-cart").fadeToggle();
  });
  
  $(".mini-cart .action a.close").click(function(e){
    //e.preventDefault()
    //$(".mini-cart").fadeOut();
  });
  
  // Scroll thumb image product - Vertical
  $(".scroll-next-old").click(function(){
    var heightcontent = $("ul.product-single__thumbnails").height() - '430';
    var liCount = $("ul.product-single__thumbnails").children().length - '5';
    //alert(heightcontent);
    
    $(this).addClass('disabled');
    setTimeout(function() {
      $(".scroll-next-old").removeClass('disabled');
    },500); 
    
    if ($("ul.product-single__thumbnails").css('marginTop') == '-' + heightcontent + 'px'){
      $(".scroll-next-old").addClass('disabled bloked');
      //$("ul.two").css({marginTop: '0px'});
    } else {
      $(".scroll-prev-old").removeClass('disabled bloked');
      $("ul.product-single__thumbnails").animate({
        marginTop: '+=-86px'
      });
    }
  });
  $(".scroll-prev-old").click(function(){

    $(this).addClass('disabled');
    setTimeout(function() {
      $(".scroll-prev-old").removeClass('disabled');
    },500); 
    
    if ($("ul.product-single__thumbnails").css('marginTop') == '0px'){
      $(".scroll-prev-old").addClass('disabled bloked');
      //$("ul.product-single__thumbnails").css({marginTop: '0px'});
    } else {
      $(".scroll-next-old").removeClass('disabled bloked');
      $("ul.product-single__thumbnails").animate({
        marginTop: '+=86px'
      });
    }
  });
  
  // Scroll thumb image product - Horizontal
  $(".scroll-next").click(function(){
    var heightcontent = $("ul.product-single__thumbnails").width() - '450';
    var liCount = $("ul.product-single__thumbnails").children().length - '5';
    //alert(heightcontent);
    
    $(this).addClass('disabled');
    setTimeout(function() {
      $(".scroll-next").removeClass('disabled');
    },500); 
    
    if ($("ul.product-single__thumbnails").css('marginLeft') == '-' + heightcontent + 'px'){
      $(".scroll-next").addClass('disabled bloked');
      //$("ul.two").css({marginTop: '0px'});
    } else {
      $(".scroll-prev").removeClass('disabled bloked');
      $("ul.product-single__thumbnails").animate({
        marginLeft: '+=-90px'
      });
    }
  });
  $(".scroll-prev").click(function(){

    $(this).addClass('disabled');
    setTimeout(function() {
      $(".scroll-prev").removeClass('disabled');
    },500); 
    
    if ($("ul.product-single__thumbnails").css('marginLeft') == '0px'){
      $(".scroll-prev").addClass('disabled bloked');
      //$("ul.product-single__thumbnails").css({marginTop: '0px'});
    } else {
      $(".scroll-next").removeClass('disabled bloked');
      $("ul.product-single__thumbnails").animate({
        marginLeft: '+=90px'
      });
    }
  });
  
  
  // List collection sidebar select
  $('#list_colnav_select_option').on('change', function () {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
  });
});

function addItemFromForm(t)
{
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    beforeSend: function() { 
      $(".loading-modalx").show();
    },
    data:  $("#"+t).serialize(),
    success: getcart,
    error: errorinfo
  });

}
function getcart()
{

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(response)
    {
      $(".loading-modalx").hide();
      $('.site-header__cart-count').html('<span>' + response.item_count + '</span>');
      $(".add-success").fadeIn().delay(3000).fadeOut(500, function(){
        //location.reload(true);
      });
    },
    error: errorinfo
  });
  
  $(".cart-box").load("https://cambridge-casual.myshopify.com" + "/cart?view=iframe");
}
function errorinfo(obj)
{
  $(".ajax-error-message").text($.parseJSON(obj.responseText).description);
  try {
    $(error_div).html(obj.description).fadeIn(300).delay(show_msg_delay).fadeOut(300);
  } catch(e) {
    $(error_div).html("There was an error").fadeIn(300).delay(show_msg_delay).fadeOut(300);
  }
}

function close_window() {
  close();
  $(".mini-cart").fadeOut();
}

      // global parameters
      var auto_select = false;

      function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
      } 

      var p_handle = findGetParameter('writereview');
      if ( p_handle != null )
      {
        auto_select = true;

        $('#ui-accordion-accordion-header-6').click();
        //$('.reviewtarget').click(); // Di hapus karna posisi tab sudah terbuka
        load();
        function load() {
          $('.write-review a[href*="#"]:not([href="#"])').click();
        }
        window.onload = load;

      }  else {
        

      }
      
  jQuery.cookie = function (key, value, options) {

    // key and value given, set cookie...
    if (arguments.length > 1 && (value === null || typeof value !== "object")) {
        options = jQuery.extend({}, options);

        if (value === null) {
            options.expires = -1;
        }

        if (typeof options.expires === 'number') {
            var days = options.expires, t = options.expires = new Date();
            t.setDate(t.getDate() + days);
        }

        return (document.cookie = [
            encodeURIComponent(key), '=',
            options.raw ? String(value) : encodeURIComponent(String(value)),
            options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
        ].join(''));
    }

    // key and possibly options given, get cookie...
    options = value || {};
    var result, decode = options.raw ? function (s) { return s; } : decodeURIComponent;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null;
};
  
  $(document).ready(function(){
    $('.button-show-newsletter').click(function(){
      $('#mc_embed_signup, #mc_embed_signup a.mc_embed_close').show();
    });
  });

  $(document).ready(function(){
    $('.pop-close2').click(function(){
      $('.cart-popup').hide();
      $('body').removeClass('ov-hidden');
    });
    
    $('#cart-b [data-toggle="mincart"]').click(function(em){
      em.preventDefault();
      var qtym = parseInt($(this).parents('.pop-qty').find('.update-qty').val()) - 1; 
      $(this).parents('.pop-qty').find('.update-qty').val(qtym);
      $(this).parents('.sub-qty').find(".pop-update").click(); 
    });
    
    $('#cart-b [data-toggle="pluscart"]').click(function(ep){
      ep.preventDefault();
      var qtyp = parseInt($(this).parents('.pop-qty').find('.update-qty').val()) + 1;
      $(this).parents('.pop-qty').find('.update-qty').val(qtyp);
      $(this).parents('.sub-qty').find('.pop-update').click(); 
    });
  });
  
  $(function(){
    $('[data-toggle="min"]').click(function(e){
      e.preventDefault();
      var qty = parseInt($('.qty-value, .sas_qty-value').val()) - 1;
      if(parseInt(qty) < 1)
        return 1;
      $('.qty-value, .sas_qty-value').val(qty);
      e.preventDefault();
    });
    $('[data-toggle="plus"]').click(function(e){
      e.preventDefault();
      var qty = parseInt($('.qty-value, .sas_qty-value').val()) + 1;
      $('.qty-value, .sas_qty-value').val(qty);
      e.preventDefault();
    });
  });
  
  /*function loadFrame() {
    if($('.stamped-main-badge .stamped-badge-caption[data-reviews]' == '0')){
      $('.tab_reviews').removeClass('ui-accordion-header-active');
      $('#cc-7').hide();
    }
  };
  window.onload = setTimeout(loadFrame, 1000);*/
  
  $('.btn-mailto').click(function(){   
    /*var body = document.getElementById("cmessage").value;
    var subject = document.getElementById("cname").value;
    window.location.replace(`mailto:hello@domain.com?body=${body}&subject=${subject} wants to contact you`); */  
    var mailto = $(this).data('mailto');
    console.log(mailto);
    window.location.replace('mailto:' + mailto);   
  });

}